<!--
  hideOnDateTimeSelect=false: no v21 o DatePicker passou a fechar sozinho quando o
  range completa (no v16 a condicao era `isSingleSelection() && hideOnDateTimeSelect`,
  entao range nunca fechava). Aqui quem fecha e o botao "Aplicar".
-->
<div class="flex align-items-center">
  <p-floatlabel variant="on">
    <p-datepicker
      size="small"
      #competencia
      [(ngModel)]="selectedCompetencias"
      view="month"
      dateFormat="yy-mm"
      selectionMode="range"
      rangeSeparator="até"
      [inputStyleClass]="inputClass"
      [ngClass]="{
        'hide-year-selector': hideYearSelector,
        'admin-mode': isAdmin
      }"
      [disabled]="disabled"
      [hideOnDateTimeSelect]="false"
      [minDate]="minDate"
      [maxDate]="maxDate"
      [disabledDates]="disabledDates"
      (onBlur)="cancelSelection()"
    >
      <ng-template pTemplate="footer">
        <div class="flex flex-row-reverse mt-2">
          <button
            type="button"
            pButton
            outlined
            size="small"
            label="Aplicar"
            (click)="competencia.toggle(); emitValue()"
            [disabled]="!selectedCompetencias || !selectedCompetencias[1]"
          ></button>
        </div>
      </ng-template>
    </p-datepicker>
    <label for="competencia">{{ label }}</label>
  </p-floatlabel>
</div>
